import DynamicReducer from 'lib/DynamicReducer';

let dynamicReducerInstance;

export function getInstance() {
    if (!dynamicReducerInstance) {
        dynamicReducerInstance = new DynamicReducer();
    }
    return dynamicReducerInstance;
}

// Can only destroy the instance in tests
export function destroyInstance() {
    if (__TESTING__) {
        dynamicReducerInstance = null;
    }
}
